import React, { useRef } from 'react';
import './crm-ui.scss';

function CrmTabs({ items = [], activeId, onChange, ariaLabel = 'Tabs', className = '' }) {
  const refs = useRef([]);

  const moveFocus = (currentIndex, direction) => {
    if (!items.length) return;
    let nextIndex = currentIndex;
    do {
      nextIndex = (nextIndex + direction + items.length) % items.length;
    } while (items[nextIndex]?.disabled && nextIndex !== currentIndex);
    refs.current[nextIndex]?.focus();
  };

  const handleKeyDown = (event, index) => {
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      moveFocus(index, 1);
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      moveFocus(index, -1);
    } else if (event.key === 'Home') {
      event.preventDefault();
      refs.current.find(Boolean)?.focus();
    } else if (event.key === 'End') {
      event.preventDefault();
      [...refs.current].reverse().find(Boolean)?.focus();
    }
  };

  return (
    <div className={`crm-tabs ${className}`.trim()} role="tablist" aria-label={ariaLabel}>
      {items.map((item, index) => {
        const isActive = item.id === activeId;
        return (
          <button
            key={item.id}
            ref={(node) => { refs.current[index] = node; }}
            type="button"
            role="tab"
            className={`crm-tabs__tab ${isActive ? 'is-active' : ''}`}
            aria-selected={isActive}
            aria-controls={item.panelId}
            tabIndex={isActive ? 0 : -1}
            disabled={item.disabled}
            onClick={() => onChange?.(item.id)}
            onKeyDown={(event) => handleKeyDown(event, index)}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}

export default CrmTabs;
